// TODO: move into environment variable
export const contact = 'client.service@erisx.com';
